<template>
  <WorkBasicDialog
    ref="webSocketDialog"
    width="sm"
  >
    <template #header>
      {{ $t('Components.sentences.youGotMail') }}
    </template>

    <template #content>
      {{ $t('Components.sentences.youGotMail') }}
    </template>
  </WorkBasicDialog>
</template>

<script>
import WorkBasicDialog from "@/components/base_components/dialog/WorkBasicDialog";

export default {
  name: "WebSocketDialog",
  components: { WorkBasicDialog },
  methods: {
    open() {
      return this.$refs.webSocketDialog.open();
    }
  },
}
</script>
